<template>
  <section class="list">
    <div class="row">
      <article
        v-for="fruit in fruits"
        :key="fruit.code"
        class="card fruit-card"
        @click="selectFruit(fruit.code)"
      >
        <h3>{{ fruit.name }}</h3>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: "SelectFruitType",

  data() {
    return {
      fruits: [
        { code: "FRESA", name: "Fresa" },
        { code: "ARANDANO", name: "Arándano" },
        { code: "ZARZAMORA", name: "Zarzamora" },
        { code: "FRAMBUESA", name: "Frambuesa" },
      ],
    };
  },

  methods: {
    selectFruit(fruitCode) {
      this.$root.$emit("farm-fruit", fruitCode);
    },
  },
};
</script>

<style scoped>
.fruit-card {
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 120px;
}

.fruit-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.fruit-card:active {
  transform: translateY(-2px);
}

h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
}
</style>
